'use client';
import { useRecoilValue } from 'recoil';
import { useWallet } from '@solana/wallet-adapter-react';
import { isEmpty } from 'lodash-es';
import { userBidsDataState, userBidsByProjectState } from '@/lib/state';

import LoadingSpinner from '@/components/LoadingSpinner';
import UserBidsTable from '@/components/UserBidsTable';

export default function BidPage() {
  const { publicKey } = useWallet();
  const bids = useRecoilValue(userBidsDataState);
  const tableData = useRecoilValue(userBidsByProjectState);

  if (!publicKey) {
    return (
      <div className="flex flex-col max-w-screen-sm lg:max-w-screen-lg">
        <div className="flex flex-col space-y-2 w-full items-center justify-center">
          {' '}
          <h1 className="text-3xl">Connect Wallet</h1>
          <p className="font-thin">To see your Live Winning Bids</p>
        </div>
      </div>
    );
  }

  if (false) {
    // Unused div to force the app to compile with styles
    return <div className="border-success border-warning" />;
  }

  if (isEmpty(tableData)) {
    return (
      <div className="flex flex-col max-w-screen-sm lg:max-w-screen-lg">
        {!bids ? (
          <div className="flex items-center space-x-2">
            <LoadingSpinner />
            <p>Please wait while we load your bids</p>
          </div>
        ) : (
          <p className="mt-8 text-xl">This wallet has not placed any bids</p>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full space-y-4 max-w-screen-sm lg:max-w-screen-lg">
      {Object.entries(tableData || {}).map(([project, pBids]) => (
        <UserBidsTable key={`${publicKey}-bids-${project}`} project={project} bids={pBids} />
      ))}
    </div>
  );
}
